// Supabase konfigurace - NOVÁ DATABÁZE
import { createClient } from '@supabase/supabase-js';

// Nová Supabase databáze (stejná jako StebexAdmin)
const SUPABASE_URL = 'https://lzrlzuqzywzilbsirsje.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6cmx6dXF6eXd6aWxic2lyc2plIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzODk2NTMsImV4cCI6MjA3NTk2NTY1M30.nFRvREiw8Km4B-OcylNM247zl54oXKgfVOgDR8q9LK0';

// ProByty website ID v nové databázi
export const PROBYTY_WEBSITE_ID = 2;

// Vytvoření Supabase klienta
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: window.localStorage
  }
});

// Zjednodušená autentizace - používá standardní Supabase Auth
export const supabaseAuth = {
  // Přihlášení
  async signIn(email, password) {
    try {
      // Použít Supabase Auth
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      
      if (error) {
        console.error('Supabase auth error:', error);
        return { 
          data: null, 
          error: { message: 'Nesprávné přihlašovací údaje' } 
        };
      }
      
      // Zkontrolovat jestli má uživatel přístup k ProByty (website_id = 2)
      const { data: userWebsite, error: websiteError } = await supabase
        .from('user_websites')
        .select('website_ids')
        .eq('user_id', data.user.id)
        .single();

      if (websiteError || !userWebsite || !userWebsite.website_ids.includes(PROBYTY_WEBSITE_ID)) {
        await supabase.auth.signOut();
        return { 
          data: null, 
          error: { message: 'Nemáte přístup k administraci ProByty' } 
        };
      }
      
      // Uložit do localStorage
      const userData = {
        ...data.user,
        website_ids: userWebsite.website_ids
      };
      
      localStorage.setItem('supabase_user', JSON.stringify(userData));
      localStorage.setItem('is_authenticated', 'true');
      
      return { 
        data: { 
          user: userData, 
          session: data.session 
        },
        error: null 
      };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        data: null, 
        error: { message: 'Chyba při přihlášení' } 
      };
    }
  },

  // Odhlášení
  async signOut() {
    await supabase.auth.signOut();
    localStorage.removeItem('supabase_user');
    localStorage.removeItem('is_authenticated');
    return { error: null };
  },

  // Získat current user
  getUser() {
    const userStr = localStorage.getItem('supabase_user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  },

  // Je přihlášený?
  isAuthenticated() {
    return localStorage.getItem('is_authenticated') === 'true';
  }
};

// Export default
export default supabase;
